import { createFileRoute } from '@tanstack/react-router';
import { GiftLogin } from '../../components/GiftLogin/GiftLogin';

export const Route = createFileRoute('/$retailer/gift-login')({
  component: GiftLogin,
});
